<span matSnackBarLabel>Une nouvelle version de l'application est disponible.</span>
<span matSnackBarActions>
  <button mat-button matSnackBarAction type="button" (click)="later()">Plus tard</button>
  <button mat-button matSnackBarAction type="button" (click)="reload()">Recharger</button>
</span>
